@import "../../../../../styles/variables.scss";

qds-button {
  min-inline-size: max-content;

  @media (max-width: $uiaas-tablet) {
    display: none;
  }
}
